<yc-modal
  [modalHeader]="'common:hdrAwardDetail' | ycI18n: 'Award Detail'"
  [modalSubHeader]="('common:textApplicationId' | ycI18n: 'Application ID') + ': ' + applicationId"
  [primaryButtonText]="'common:textClose' | ycI18n: 'Close'"
  (onPrimaryClick)="closeModal.emit()">
  <gc-awards
    [applicationId]="applicationId"
    [awards]="adaptedAwards"
    [isForApplicantPortal]="true">
  </gc-awards>
</yc-modal>